import { Menu, MenuItem, Link } from '@mui/material';
import { useState } from 'react';
import { MoreVerticalIcon } from '../../icons/index.js';
import { OptionsFileButton } from './styled.js';
import { jsxs, Fragment, jsx } from 'react/jsx-runtime';

const FileOptionsMenu = props => {
  const {
    onRemove,
    onReplace,
    downloadUrl,
    labels
  } = props;
  const [anchorEl, setAnchorEl] = useState(null);
  const handleRemoveFile = event => {
    event.stopPropagation();
    onRemove(event);
    setAnchorEl(null);
  };
  const handleMoreButtonClick = event => {
    event.stopPropagation();
    setAnchorEl(event.currentTarget);
  };
  const handleMoreMenuClose = event => {
    event.stopPropagation();
    setAnchorEl(null);
  };
  return /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsx(OptionsFileButton, {
      onClick: handleMoreButtonClick,
      children: /*#__PURE__*/jsx(MoreVerticalIcon, {})
    }), /*#__PURE__*/jsxs(Menu, {
      anchorEl: anchorEl,
      open: Boolean(anchorEl),
      onClick: event => handleMoreMenuClose(event),
      onClose: handleMoreMenuClose,
      children: [/*#__PURE__*/jsx(MenuItem, {
        onClick: handleRemoveFile,
        children: labels?.delete ?? 'Delete'
      }), downloadUrl && /*#__PURE__*/jsx(MenuItem, {
        component: Link,
        href: downloadUrl,
        children: labels?.download ?? 'Download'
      }), /*#__PURE__*/jsx(MenuItem, {
        onClick: onReplace,
        children: labels?.replace ?? 'Replace'
      })]
    })]
  });
};

export { FileOptionsMenu };
